import React from 'react';
import { List, Button } from 'antd';
import { getValues,getValueOrDefault  } from '../../virtuoso/helper';
import { TEAMWORK, DCTERMS } from '../../const/C';

/** Отображение краткой информации о wiki с сылкой на статью. 
 * canDeleted - флаг редактировния */
export const WikiPageListItem = ({page, lang, canDeleted, onDelete, onClick=f=>f}) => {
  const IRI = page.object.value;
  const header = (page.values)? getValues(DCTERMS.TITLE, lang, page.values):IRI;
  const description = (page.values)? getValueOrDefault(DCTERMS.DESCRIPTION, lang, page.values, ''):IRI;
  let URL = (page.values)? getValues(TEAMWORK.SKSA_PREDICAT_WIKI, lang, page.values):IRI;
  if (Array.isArray(URL) && URL.length==0 ){
    const urlV1 = (page.values)? getValues(TEAMWORK.PREDICAT_WIKI, lang, page.values):IRI;
    if (Array.isArray(urlV1) && urlV1.length==0 )
      URL = undefined;
  }
  const actions= (canDeleted)?
    [
      <Button type="link" block onClick={(e)=>onDelete(e, IRI, header)}><span className="csi_cat_title">X</span></Button>
    ]:[];
  return(
    <List.Item actions={actions} style={{borderRadius: 0}}>
      <List.Item.Meta 
        title={
          (URL?
            (canDeleted ? 
              <Button type="link" block onClick={(e)=>onClick(e, IRI)}>
                <span className="csi_cat_title" style={{color: "#0b5fff"}}>{header}</span>
              </Button>
              :
              <a href={URL} target="_blank">
                <span className="csi_cat_title" style={{color: "#0b5fff"}}>{header}</span>
              </a>
            )          
          :
          <span className="csi_cat_title">{header}</span>
          )
        }
        description={description}
      />
    </List.Item>
  )
}